import type { BlueprintRole } from '@mn/shared';

// Canonical default role-visibility sets for nav items. This is a dependency-free leaf
// module so both nav-config.ts and the module nav.ts files can import the VALUES without
// creating an import cycle. Keep these as the single source of truth.
export const FUNDS_ROLES: BlueprintRole[] = ['BLUEPRINT_ADMIN', 'PROJECT_MANAGER', 'ELDER', 'PASTOR'];
export const BUILD_ROLES: BlueprintRole[] = ['BLUEPRINT_ADMIN', 'PROJECT_MANAGER', 'TRADES', 'ELDER', 'PASTOR'];
export const PEOPLE_ROLES: BlueprintRole[] = ['BLUEPRINT_ADMIN', 'PROJECT_MANAGER', 'ELDER', 'PASTOR', 'MINISTRY_LEADER'];
/**
 * BUILD ∪ PEOPLE — everyone except CONGREGATION_MEMBER.
 *
 * Mirrors `requireBlueprintRoster()` on the API, which is what guards attachment
 * reads: a file can be attached to a Build entity (permit, RFI, change order) or
 * a People one (ministry space), so the nav entry has to be visible to the union
 * of both. Keep in step with blueprint-auth.ts.
 */
export const ROSTER_ROLES: BlueprintRole[] = ['BLUEPRINT_ADMIN', 'PROJECT_MANAGER', 'TRADES', 'ELDER', 'PASTOR', 'MINISTRY_LEADER'];
